<template lang="html">
    <div>
        <no-subscription v-if="NoSubscription"></no-subscription>
        <ns-paginate
            v-else
            v-model="applicationPaginateRequest"
            baseUrl="application/"
            class="app-view"
            :displayCsvButton="false"
            :vLoadingData="{background: 'rgba(48,48,48,0.9)'}"
            :customItemPageLength="itemPerPageRelatedToScreenWidth"
            :customFiltersToApply="labelFilterToApply"
            :display-search-bar="false"
            ref="nsPaginate"
        >
            <!-- Search bar disabled (#109) -->
            <!-- prop ns-paginate rétirée :filters="[{key: 'label', verbose: 'Name'}]" -->
            <div
                slot="filter"
                slot-scope="props"
            >
            <v-text-field
                v-model="labelFilter"
                :label="$t('application.index.search_field_title')"
                :placeholder="$t('application.index.search_field_placeholder')"
                :clearable="true"
                class="input-bottom-line"
                @input="loadContent(props.applyFilters)"
            >
            </v-text-field>
            </div>
            <div
                slot="reload"
                
            >
            </div>
            <template
                slot="list"
                slot-scope="props"
            >
                <v-container
                    fluid
                    class="instances-container"
                >
                    <v-row no-gutters>
                        <v-col
                            col="4"
                            sm="3"
                            md="2"
                            lg="2"
                            xl="1"
                            class="create-app-container"
                        >
                            <form-create-app
                                :applicationsCount="totalApplicationsCount"
                                triggerComponent="create-btn"
                                @reloadApplications="reloadApplications"
                            ></form-create-app>
                        </v-col>
                        <template v-if="props.list.length">
                            <v-col
                                v-for="app in props.list"
                                :key="app.uid"
                                col="4"
                                sm="3"
                                md="2"
                                lg="2"
                                xl="1"
                            >
                                <app-btn
                                    :show-delete-btn="false"
                                    :application="app"
                                    :callback="setApplication"
                                    @refreshContent="refreshModel"
                                ></app-btn>
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col
                                col="8"
                                sm="9"
                                md="10"
                                lg="10"
                                xl="11"
                                class="no-content"
                            >
                                <template v-if="!labelFilter">{{$t('application.index.create_first')}}</template>
                                <template v-else>{{$t('application.index.search_no_result')}} "{{labelFilter}}"</template>
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </template>
            <div
                slot="pagination"
                slot-scope="props"
            >
                <v-pagination
                    v-if="applicationPaginateRequest.num_total_pages > 1"
                    dark
                    v-model="currentPage"
                    :length="props.pageCount"
                    :total-visible="6"
                    class="app-pagination"
                ></v-pagination>
            </div>
        </ns-paginate>
    </div>
</template>
<script>
import FormCreateApp from './form-create-app.vue';
import AppBtn from '@/components/Partials/app-btn.vue';
import NoSubscription from './no-subscriptions.vue';
export default {
    components: {
        NoSubscription,
        FormCreateApp,
        AppBtn,
    },
    data() {
        return {
            applicationPaginateRequest: {},
            currentPage: 1,
            labelFilter: '',
            searchTimeoutId: null,
        };
    },
    computed: {
        itemPerPageRelatedToScreenWidth (){
            if(this.$store.getters.getWw > 1904){
                return 23;
            }else{
                return 11;
            }
        },
        NoSubscription (){
            return Number.isNaN(this.$store.getters.allowedInstances);
        },
        totalApplicationsCount(){
            return this.$store.getters.applicationsCount;
        }
    },
    watch: {
        currentPage(val) {
            this.$refs.nsPaginate.loadSpecificPage(val);
        },
        applicationPaginateRequest: {
            handler(val) {
                this.currentPage = val.num_current_page;
            },
            deep: true,
        },
    },
    mounted (){
    },
    methods: {
        reloadApplications() {
            this.$refs.nsPaginate.loadContent();
        },
        setApplication(app) {
            this.$store.commit('SET_CURRENT_APPLICATION', app);
            this.$router.push({name: 'instances', params: {applicationUid: app.uid}});
        },

        labelFilterToApply (){
            return {
                search: this.labelFilter === null ? '' : this.labelFilter,
                archived: false,
            };
        },

        loadContent (loadContent){
            clearTimeout(this.searchTimeoutId);
            let timeout = 500;
            if(this.labelFilter === null){
                // en cas de clear on veut que le chargement des données soit instantané
                timeout = 1;
            }
            this.searchTimeoutId = setTimeout(loadContent, timeout);
        },
        refreshModel() {
            this.$refs.nsPaginate.loadContent();
        }
    }
};

</script>
<style lang="scss">
.app-view{
    .blockLoading{
        width: 95%;
        margin: 30px;
        // overriding the background of the ns paginate loader
        background-color: #303030 !important;

        .el-loading-mask{
            background-color: #303030;
        }
    }
    .no-content{
        height: 120px;
        line-height: 110px;
        font-size: 35px;
        color: #828282;
        font-weight: 400;
    }
    .create-app-container {
        .create {
            z-index: 2;
        }
    }
}
.app-pagination {
    margin: 30px 0px;
}
.instances-container{
    padding-left: 0;
}
.input-bottom-line{
    margin-right: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Application/index.vue